export const fieldNames = {
  messageField: 'messageField',
};
